import { render, staticRenderFns } from "./ServiceCustomer.vue?vue&type=template&id=7a17ad01&"
import script from "./ServiceCustomer.vue?vue&type=script&lang=js&"
export * from "./ServiceCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports